<template>
    <md-list class="md-dense contacts" v-if="contacts.length > 0">
        <md-list-item v-for="contact in contacts" :key="contact.id" class="mb-1">
            <div class="md-list-item-text flex-row items-center justify-between">
                <span class="w-auto">{{ contactFullName(contact) }}</span>
                <div class="w-auto flex items-center divide-x-2 divide-gray-300">
                    <div class="w-auto pr-2">
                        <div class="flex align-items divide-x-2 divide-gray-300">
                            <div class="w-auto pr-2">
                                <span class="font-bold">T : </span>
                                <span>{{ contact.phone }}</span>
                            </div>
                            <div class="w-auto pl-2">
                                <span class="font-bold">M : </span>
                                <span>{{ contact.mobile }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="w-auto pl-2">
                        <md-button class="md-icon-button md-raised md-info" :href="'mailto:' + contact.email">
                            <i class="md-icon fa fa-envelope" />
                        </md-button>
                        <md-tooltip md-direction="top">{{ contact.email }}</md-tooltip>
                    </div>
                </div>
            </div>
        </md-list-item>
    </md-list>
    <span v-else class="ml-1">Ø</span>
</template>

<script>
export default {
    name: "ContactsList",
    props: {
        contacts: Array,
    },
    methods: {
        contactFullName(contact) {
            return contact.last_name + ' ' + contact.first_name
        },
    }
}
</script>

<style scoped>

</style>
